import { ComboBox, Stack, StackItem, TextField, Toggle, IComboBoxOption } from '@fluentui/react';
import * as React from 'react';

interface IUserListFilterProps {
    text: string;
    setText: (text: string) => void;
    role: string;
    setRole: (text: string) => void;
    aktivni: boolean;
    setAktivni: (aktivni: boolean) => void;
}


const role: IComboBoxOption[] = [
    { key: "UserAdmin", text: "Administrator" },
    { key: "Teacher", text: "Lektor" },
    { key: "Accountant", text: "Účetní" },
    { key: "", text: "Nerozhoduje" },
]

export const UserListFilter: React.FunctionComponent<IUserListFilterProps> = (props) => {




    return (<Stack padding={10} tokens={{ childrenGap: 10 }} horizontal verticalAlign="center">
        <StackItem grow>
            <TextField value={props.text} onChange={(e, v) => props.setText(v?v:"")} label="Jmnéno uživatele" placeholder="Zadejte hledané jméno" />
        </StackItem>
        <StackItem grow>
            <ComboBox label="Uživatele s rolí" options={role} onChange={(e, o) => props.setRole(o ? o.key.toString() : "")} />
        </StackItem>
        <StackItem grow>
            <Toggle label="Pouze aktivní uživatele" checked={props.aktivni} onChange={(e, ch) => props.setAktivni(ch?true:false)}></Toggle>
        </StackItem>
    </Stack>)
}
